type LogoutFn = (opts?: { silent?: boolean }) => void;

let logoutHandler: LogoutFn | null = null;

/** 由 useLogin 在挂载时注册当前 logout，保证全局仅一处订阅也能调用到最新登出逻辑 */
export function registerLogoutHandler(fn: LogoutFn): void {
  logoutHandler = fn;
}

export function unregisterLogoutHandler(fn: LogoutFn): void {
  if (logoutHandler === fn) {
    logoutHandler = null;
  }
}

export function dispatchLogout(opts?: { silent?: boolean }): void {
  logoutHandler?.(opts);
}
